import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { giphyLightBlue, giphyBlue, giphyPurple, giphyGreen } from '../../../../styles/colors'
import { mobile } from '../../../utils/media-query'

type ContainerProps = {
    toggleGradient?: string
}
const Container = styled.div<ContainerProps>`
    display: flex;
    height: 42px;
    margin-bottom: 15px;
    position: relative;
    background: transparent;
    color: black;
    border: black solid 1px;
    font-family: 'PT Mono', monospace;
    font-weight: bold;

    ${({ toggleGradient }) =>
        toggleGradient &&
        css`
            border-image-source: ${toggleGradient};
            border-image-slice: 1;
        `}
`

const ToggleSelection = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    background-color: black;
    transition: left 200ms ease-out, background-position 200ms ease-out;

    ${mobile.css`
        background: linear-gradient(to right, ${giphyPurple}, ${giphyGreen});
        background-size: 200%;
        background-position: 0;
    `}
`

const Label = styled.label`
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    width: 50%;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    color: black;
`

type InputProps = {
    textGradient?: string
}
const Input = styled.input<InputProps>`
    display: none;

    &:checked {
        + label {
            transition: color 200ms ease-out;
        }

        + .label1 {
            color: ${giphyLightBlue};
        }

        + .label2 {
            color: ${giphyBlue};

            ~ span {
                left: 50%;
                background-position: 99%;
            }
        }

        ${mobile.css`
            + label {
                background-color: transparent;
            }
            + .label1,
            + .label2 {
                span {
                    color: black;
                    -webkit-text-fill-color: black;
                }
            }
        `}
    }

    ${({ textGradient }) =>
        textGradient &&
        css`
            + .label1,
            + .label2 {
                span {
                    display: block;
                    background: ${textGradient};
                    /* styled-components doesn't prefix background-clip */
                    -webkit-background-clip: text;
                    background-clip: text;
                    /* no non prefixed version for -webkit-text-fill-color */
                    -webkit-text-fill-color: transparent;
                    color: transparent;
                }
            }
        `}
`

type ToggleProps = {
    option1: string
    option2: string
    onChange1: () => void
    onChange2: () => void
    textGradient?: string
    toggleGradient?: string
    currentSelected: string
    name: string
}

const Toggle = ({
    option1,
    option2,
    onChange1,
    onChange2,
    textGradient,
    toggleGradient,
    currentSelected,
    name,
}: ToggleProps) => {
    const [selected, setSelected] = useState(currentSelected)

    const onChange = (e: any) => {
        setSelected(e.target.value)
    }

    return (
        <Container toggleGradient={toggleGradient}>
            <Input
                type="radio"
                checked={selected === option1}
                id={option1}
                value={option1}
                textGradient={textGradient}
                name={name}
                onChange={e => {
                    onChange(e)
                    onChange1()
                }}
            />
            <Label htmlFor={option1} className="label1">
                <span>{option1}</span>
            </Label>
            <Input
                type="radio"
                checked={selected === option2}
                id={option2}
                value={option2}
                textGradient={textGradient}
                name={name}
                onChange={e => {
                    onChange(e)
                    onChange2()
                }}
            />
            <Label htmlFor={option2} className="label2">
                <span>{option2}</span>
            </Label>
            <ToggleSelection />
        </Container>
    )
}

export default Toggle
